import { createAsyncAction } from '@/redux/root';

export const nameSpace = '@@/sales-areas';

export const requestSalesAreasAsync = createAsyncAction(`${nameSpace}/REQUEST_SALES_AREAS`);

export const addSalesAreaAsync = createAsyncAction(`${nameSpace}/ADD_SALES_AREA`);

export const updateSalesAreaAsync = createAsyncAction(`${nameSpace}/UPDAT_SALES_AREA`);
